module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-MediExte.0b0cfa2.ttf";